export default {
  error: '',
  data: [],
  select: {},
  latestAsset: '',
  inProgress: false,
  cropimageLink: '',
};
